import { Spine } from "@esotericsoftware/spine-pixi-v8";
// import { sound } from "@pixi/sound";
import { sound } from "@pixi/sound";
import { DestroyOptions } from "pixi.js";
import { isSuperQuickBtnOnGlobal } from "../../config/GlobalVariableConfig";
import { DisplayObject, IDisplayObject } from "../../core/displays/DisplayObject";
import { Manager } from "../../core/Manager";
import { SoundConstants } from "../../gameClientEvents/soundConstants";

export class GunShoot extends DisplayObject {
    private hand: Spine | null = null;
    private intendedAnim: string;

    constructor(config: IDisplayObject) {
        super(config);
        this.setPositionResize(Manager.Orientation || "LANDSCAPE");
        this.init();
        this.subscribeToEvents();
    }

    public override destroy(options?: DestroyOptions): void {
        this.unsubscribeToEvents();
        super.destroy(options);
    }

    public playShoot(fire: number): void {
        switch (fire) {
            case 1:
                this.intendedAnim = "win_1";
                break;
            case 2:
                this.intendedAnim = "win_2";
                break;
            case 3:
                this.intendedAnim = "win_3";
                break;
            default:
                this.intendedAnim = "idle";
        }
        this.hand?.state.setEmptyAnimation(0, 0);
        this.hand?.state.setAnimation(0, `${this.intendedAnim}`, false);
    }

    public speedupCharacterAnim() {
        this.hand.state.timeScale = 2;
    }

    public resetSpeedCharacterAnim() {
        this.hand.state.timeScale = 1;
    }

    private init(): void {
        this.hand = Spine.from({
            skeleton: "gunShootSkel",
            atlas: "gunShootAtlas"
        });

        const animations = this.hand.skeleton.data.animations.map(anim => anim.name);
        console.log("Available hand animations:", animations);

        const data = this.hand.state.data;
        data.defaultMix = 0.25;

        this.addChild(this.hand);
        this.hand?.state.setEmptyAnimation(0, 0);
        this.hand.state.setAnimation(0, "loop", false);
        this.hand.state.timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
        this.hand.visible = false;
    }

    public showHand() {
        if (this.hand) {
            this.hand.visible = true;
            this.hand.state.setEmptyAnimation(0, 0);

            sound.play(SoundConstants.GUNSLINGER, { volume: 1 });
            this.hand.state.setAnimation(0, "intro", false);
            this.hand.state.addAnimation(0, "loop", false, 0);
            this.hand.state.addAnimation(0, "outro", false, 0);

            this.hand.state.addListener({
                complete: (listenerAnim) => {
                    if (listenerAnim.animation.name === "outro") {
                        this.hand.state.setEmptyAnimation(0, 0);
                        this.hand.state.clearListeners();
                        this.hand.visible = false;
                    }
                }
            });
        }
    }

    private subscribeToEvents() {
        this.hand.eventMode = "static";
        // this.hand.on("pointerdown", this.onHandClick);
    }

    private unsubscribeToEvents() {
        this.hand.state.clearListeners();
        this.hand.eventMode = "static";
        // this.hand.off("pointerdown", this.onHandClick);
    }

    public override setPositionResize(orientation: string) {
        super.setPositionResize(orientation);
        if (this.hand) {
            if (orientation === "LANDSCAPE") {
                const scale = 1 * Math.min(Manager.screenwidth / 1920, Manager.screenHeight / 1080);
                this.hand.x = -this.parent.x / scale;
                //this.hand.y = this.parent.y / scale;
            } else {
                const scale = 1 * Math.min(Manager.screenwidth / 1080, Manager.screenHeight / 1920);
                this.hand.x = -this.parent.x / scale;
                //this.hand.y = this.parent.y / scale;
            }
        }

    }
}
